import { MutationTree } from 'vuex';
import { IState } from './types';

const mutations: MutationTree<IState> = {
  setIsVideoPlayed(state, isPlayed?) {
    state.isVideoPlayed = isPlayed;
  }
};

export default mutations;
